var _circle, _circle2, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusOrangeCircleWhiteOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#E74"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#E74",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.063 11.063V8.25c0-.518.447-.937 1-.937.552 0 1 .42 1 .937v2.814h2.687c.518 0 .938.448.938 1 0 .553-.42 1-.938 1h-2.688v2.686c0 .518-.447.937-1 .937-.552 0-1-.42-1-.937v-2.686H8.25c-.518 0-.938-.447-.938-1 0-.552.42-1 .938-1h2.813z",
    fill: "#fff"
  })));
}

export default SvgPlusOrangeCircleWhiteOutlined;